import React from "react";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import {
  hideLoadingScreen,
  showLoadingScreen,
} from "../../store/slices/loading";
import DeptoChart from "../Charts/DeptoChart";
import { getDeptos, getPersonas } from "../../services/apiRequests";
import { setPersonasList } from "../../store/slices/personas";
import { setDeptosList } from "../../store/slices/deptos";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const mapStyles = {
  width: "100%",
  height: "800px",
  minHeight: "50vh",
  borderRadius: "5px",
  overflow: "hidden",
};
const cellDataStyle = "rgba(104, 188, 188, 0.2)";
const Map = ({ userApiKey }) => {
  const [markerDataList, setMarkerDataList] = React.useState([])
  const [fetchingData, setFetchingData] = React.useState(false)
  const dispatch = useDispatch();

  const deptosList = useSelector((state) => state.deptosList.data);
  const personasList = useSelector((state) => state.personasList.data);
  const userData = useSelector((state) => state.userData.data);

  const getPersonasList = () => {
    getPersonas(userApiKey, userData.id).then((data) => {
      if (data.length > 0) {
        dispatch(setPersonasList([...data]));
      } else {
        dispatch(setPersonasList([]));
      }
      dispatch(hideLoadingScreen());
      setFetchingData(false)
    });
  };

  const renderMarker = (deptoData) => {
    return (
    <Marker position={[deptoData.latitud, deptoData.longitud]} key={deptoData.nombre + deptoData.latitud}>
      <Popup>
        <h3>{deptoData.nombre}</h3>
        Censados: <b>{deptoData.censados}</b>
      </Popup>
    </Marker>
    )
  }

  React.useEffect(() => {
    if (personasList.length === 0) {
      setFetchingData(true)
      dispatch(showLoadingScreen());
      getPersonasList();
    }
    if (deptosList.length === 0) {
      setFetchingData(true)
      dispatch(showLoadingScreen());
      const getDeptosList = () => {
        getDeptos(userApiKey, userData.id).then((data) => {
          dispatch(setDeptosList(data));
          dispatch(hideLoadingScreen());
          setFetchingData(false)
        });
      };
      getDeptosList();
    }
  }, []);

  return (
    <Stack
      flexDirection={{ xs: "column", md: "row" }}
      justifyContent={"flex-start"}
      alignItems={"flex-start"}
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          m: "10px",
          width: { xs: "calc(100% - 20px)", md: "calc(50% - 20px)" },
          maxHeight: "80vh",
          mr: { xs: "10px", md: "5px" },
        }}
      >
        <MapContainer
          center={[-32.741082231501245, -55.98632812500001]}
          zoom={7}
          style={mapStyles}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {markerDataList.map(depto => renderMarker(depto))}
        </MapContainer>
      </Box>

      <Paper
        elevation={2}
        sx={{
          m: "10px",
          width: { xs: "calc(100% - 20px)", md: "calc(50% - 20px)" },
          minWidth: 128,
          minHeight: 128,
          height: "800px",
          flexGrow: 1,
          backgroundColor: cellDataStyle,
          ml: { xs: "10px", md: "5px" },
          backgroundColor: "rgba(30, 90, 90, 0.4)",
        }}
      >
        {!(personasList.length > 0) ? (
          (!fetchingData) ? (
            <i>No hay ningun registro</i>
          ) :
          (<Stack
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              width: "100%",
              height: "100%",
            }}
          >
            <CircularProgress />
            <Typography> Trayendo datos...</Typography>
          </Stack>)
        ) : (
          deptosList && (
            <DeptoChart
              deptosList={deptosList}
              personasList={personasList}
              setMarkerDataList={setMarkerDataList}
            ></DeptoChart>
          )
        )}
      </Paper>
    </Stack>
  );
};
export default Map;
